import { Intersect, ClickOutside } from 'vuetify/directives'

export default {
  Intersect,
  ClickOutside,
}
